import type { PartitionStatusContext, SmartIconStatusRule, ZoneStatusContext } from './types';

const pluralize = (count: number, singular: string, plural = `${singular}s`): string =>
  `${count} ${count === 1 ? singular : plural}`;

export const PARTITION_STATUS_RULES: ReadonlyArray<SmartIconStatusRule<PartitionStatusContext>> = [
  {
    test: ({ partitionCount }) => !partitionCount,
    variant: 'disarmed',
    label: () => 'No partitions'
  },
  {
    test: ({ alarmPartitions }) => Boolean(alarmPartitions),
    variant: 'alarm',
    label: ({ alarmPartitions }) => `${pluralize(alarmPartitions, 'partition')} in alarm`
  },
  {
    test: ({ delayPartitions }) => Boolean(delayPartitions),
    variant: 'transitional',
    label: ({ delayPartitions }) => `${pluralize(delayPartitions, 'partition')} in delay`
  },
  {
    test: ({ notReadyPartitions }) => Boolean(notReadyPartitions),
    variant: 'attention',
    label: ({ notReadyPartitions }) => `${pluralize(notReadyPartitions, 'partition')} not ready`
  },
  {
    test: ({ armedPartitions }) => Boolean(armedPartitions),
    variant: 'armed',
    label: ({ armedPartitions }) => `${pluralize(armedPartitions, 'partition')} armed`
  },
  {
    test: ({ hasStatusData }) => !hasStatusData,
    variant: 'disarmed',
    label: ({ partitionCount }) => pluralize(partitionCount, 'partition')
  },
  {
    test: () => true,
    variant: 'normal',
    label: ({ partitionCount }) => `${pluralize(partitionCount, 'partition')} ready`
  }
];

export const ZONE_STATUS_RULES: ReadonlyArray<SmartIconStatusRule<ZoneStatusContext>> = [
  {
    test: ({ zoneCount }) => !zoneCount,
    variant: 'disarmed',
    label: () => 'No zones'
  },
  {
    test: ({ alarmZones }) => Boolean(alarmZones),
    variant: 'alarm',
    label: ({ alarmZones }) => `${pluralize(alarmZones, 'zone')} in alarm`
  },
  {
    test: ({ violatedZones }) => Boolean(violatedZones),
    variant: 'violated',
    label: ({ violatedZones }) => `${pluralize(violatedZones, 'zone')} open while armed`
  },
  {
    test: ({ troubleZones }) => Boolean(troubleZones),
    variant: 'trouble',
    label: ({ troubleZones }) => `${pluralize(troubleZones, 'zone')} in trouble`
  },
  {
    test: ({ openZones }) => Boolean(openZones),
    variant: 'attention',
    label: ({ openZones }) => `${pluralize(openZones, 'zone')} open`
  },
  {
    test: ({ bypassedZones }) => Boolean(bypassedZones),
    variant: 'armed',
    label: ({ bypassedZones }) => `${pluralize(bypassedZones, 'zone')} bypassed`
  },
  {
    test: ({ hasStatusData }) => !hasStatusData,
    variant: 'disarmed',
    label: ({ zoneCount }) => pluralize(zoneCount, 'zone')
  },
  {
    test: () => true,
    variant: 'normal',
    label: ({ zoneCount }) => `${pluralize(zoneCount, 'zone')} closed`
  }
];
